//http://stackoverflow.com/questions/11347779/jquery-exclude-children-from-text
$.fn.ignore = function(sel){
  return this.clone().find(sel||">*").remove().end();
};